import React from "react";

export default function TopBox({ allTopBoxItem, topBoxItem }) {
  const { title, title2, text, id } = topBoxItem;
  return (
    <div className={`topBox`} key={id}>
      {title && <h2 className="gradientText">{title}</h2>}
      {title2 && <h3 className="gradientText">{title2}</h3>}
      {text && <p>{text}</p>}
    </div>
  );
}
